import React from 'react';
export default function Stats({ stats, statsSettings }) {
    var _a, _b;
    const { nbHits, processingTimeMS } = stats;
    const { showProcessingTime, translations, } = statsSettings;
    return (React.createElement(React.Fragment, null,
        nbHits,
        ' ',
        nbHits === 1 ? ((_a = translations === null || translations === void 0 ? void 0 : translations.resultFound) !== null && _a !== void 0 ? _a : 'result found') : ((_b = translations === null || translations === void 0 ? void 0 : translations.resultsFound) !== null && _b !== void 0 ? _b : 'results found'),
        (showProcessingTime !== null && showProcessingTime !== void 0 ? showProcessingTime : false) && (React.createElement(React.Fragment, null,
            ' ',
            processingTimeMS,
            "ms"))));
}
